import { Skeleton } from "@mui/material";
import React from "react";
import "../MapView.css";

interface MapFallbackProps {
    height?: number;
}

const MapFallback: React.FC<MapFallbackProps> = (props) => {
    const height = props.height || 300;
    return (
        <div className="mapView" style={{ height: `${height}px` }}>
            <Skeleton className="mapView__skeleton" variant="rounded" />
        </div>
    );
};

export default MapFallback;
